import Vue, { ComponentOptions } from 'vue';
import VueRouter, { Route } from 'vue-router';
import { store } from '@/store';
import { getLocale } from '@/i18n';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    component: () => import(/* webpackChunkName: "main" */ '../views/Main.vue'),
  },
  // {
  //   path: '/search',
  //   name: 'search',
  //   component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'),
  // },
  {
    path: '*',
    name: 'Article',
    component: () => import(/* webpackChunkName: "article" */ '../views/Article.vue'),
    beforeEnter: async (to: Route, from: Route, next: Function) => {
      if (store.state.onCriticalError) {
        return next();
      }
      const res = await store.dispatch('ContentModule/preloadPage', {
        locale: getLocale(),
        url: to.path,
      });

      if (!res && store.state.ContentModule.redirectUrl.length) {
        return next({
          params: {
            lang: getLocale(),
          },
          query: to.query,
          path: store.state.ContentModule.redirectUrl,
        });
      }
      return next();
    },
  },
];

const [
  lang,
  folder,
] = window.location.pathname.split('/').filter((item) => item.length);

let path = process.env.BASE_URL;
if (folder && (folder.indexOf('help') !== -1 || folder.indexOf('help2') !== -1) && process.env.NODE_ENV === 'production') {
  path = `/${lang}/${folder}`;
} else if (process.env.NODE_ENV === 'production') {
  path = `/${lang}`;
}

const router = new VueRouter({
  mode: 'history',
  base: path,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        // , offset: { x: 0, y: 10 }
      };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach(async (to, from, next) => {
  const { layout } = (to.matched[0]?.components.default as ComponentOptions<Vue>);
  if (layout && store.getters.layout !== layout) {
    store.commit('SET_LAYOUT', layout);
  }

  if (to.path.indexOf('search') !== -1) {
    return next();
  }
  if (to.path[to.path.length - 1] !== '/') {
    return next({ path: `${to.path}/${to.hash ? to.hash : ''}` });
  }
  store.commit('MenuModule/setActive', to.path);
  return next();
});

export default router;
